function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import { flexSpotItem } from '../prop-types';
var FoldOutComponent = function FoldOutComponent(_ref) {
  var elements = _ref.elements,
    show = _ref.show,
    randomNumber = _ref.randomNumber,
    onDiscoverMore = _ref.onDiscoverMore,
    footerData = _ref.footerData;
  if (!elements) return /*#__PURE__*/React.createElement("div", null, "Foldout has no elements");
  return /*#__PURE__*/React.createElement("div", {
    className: "foldout ".concat(show ? 'show' : ''),
    "data-scroll": randomNumber
  }, elements.map(function (element, index) {
    var hasImage = '';
    var _element$items = _slicedToArray(element.items, 3),
      firstItem = _element$items[0],
      secondItem = _element$items[1],
      classNamesItem = _element$items[2];
    var classNames = classNamesItem ? classNamesItem.html.html : '';
    if (firstItem && secondItem && (firstItem.type === 'image' || secondItem.type === 'image')) {
      hasImage = 'has-image';
    }
    if (firstItem && secondItem && (firstItem.type === 'video' || secondItem.type === 'video')) {
      hasImage = 'has-video';
    }
    return /*#__PURE__*/React.createElement("div", {
      key: "element-".concat(index, " ").concat(randomNumber),
      className: "foldout__element ".concat(classNames, " ").concat(hasImage)
    }, secondItem && /*#__PURE__*/React.createElement("div", {
      className: "foldout__item ".concat(secondItem.type),
      key: index + 2,
      dangerouslySetInnerHTML: {
        __html: secondItem.html.html
      }
    }), firstItem && /*#__PURE__*/React.createElement("div", {
      className: "foldout__item ".concat(firstItem.type),
      key: index + 10,
      dangerouslySetInnerHTML: {
        __html: firstItem.html.html
      }
    }));
  }), elements.length > 0 && /*#__PURE__*/React.createElement(CloseButton, {
    onDiscoverMore: onDiscoverMore,
    randomNumber: randomNumber,
    closeLink: footerData.closeLink
  }));
};
var CloseButton = function CloseButton(_ref2) {
  var onDiscoverMore = _ref2.onDiscoverMore,
    randomNumber = _ref2.randomNumber,
    closeLink = _ref2.closeLink;
  return /*#__PURE__*/React.createElement("div", {
    className: "foldout__button"
  }, /*#__PURE__*/React.createElement("a", {
    href: "",
    className: "button",
    onClick: function onClick(e) {
      e.preventDefault();
      onDiscoverMore();
      document.querySelector(".foldout[data-scroll=\"".concat(randomNumber, "\"]")).parentElement.scrollIntoView(true);
    }
  }, closeLink));
};
FoldOutComponent.propTypes = {
  elements: PropTypes.arrayOf(PropTypes.shape({
    items: PropTypes.arrayOf(flexSpotItem)
  })).isRequired,
  show: PropTypes.bool.isRequired
};
export default FoldOutComponent;